import Icon from '../components/Icon.vue'

Icon.register({
  'apple-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M350.9 129C376.8 133.7 398.1 147.7 414.8 171 429.4 191.7 439.4 217.7 444.7 249 449.4 277.7 449.1 306.3 443.7 335 435.7 382.3 419.8 422 395.8 454 367.2 492.7 331.2 512 287.9 512 277.3 512 265.6 508.7 253 502 244.3 496.7 234.7 494 224 494S203.7 496.7 195 502C182.4 508.7 170.7 512 160.1 512 116.8 512 80.8 492.7 52.2 454 28.2 422 12.2 382.3 4.3 335-1.1 306.3-1.4 277.7 3.3 249 8.6 217.7 18.6 191.7 33.2 171 49.9 147.7 71.2 133.7 97.1 129 113.1 126.3 135.1 128.7 163.1 136 187 142.7 207.3 150.7 224 160 240.6 150.7 260.9 142.7 284.9 136 312.9 128.7 334.9 126.3 350.9 129zM295.9 88C286.6 96.7 274.3 103 259 107 248.3 110.3 236.7 112 224 112L209 111C207.7 101.7 207.7 91 209 79 211.7 55 219.3 36.7 232 24 241.3 15.3 253.6 9 268.9 5 279.6 1.7 291.2 0 303.9 0L318.9 1 319.9 16C319.9 28.7 318.2 40.3 314.9 51 310.9 66.3 304.6 78.7 295.9 88z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/apple-alt.js
// module id = CJiU
// module chunks = 144